// Bank
export const VIEW_ALL_BANKS = 'VIEW_ALL_BANKS';
export const CREATE_USER_ACCOUNT = 'CREATE_USER_ACCOUNT';
export const CHANGE_APPLICATION_STATUS = 'CHANGE_APPLICATION_STATUS';
export const COMMENT_APPLICATION = 'COMMENT_APPLICATION';
export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT';
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const DOWNLOAD_APPLICANT_DOCUMENT = 'DOWNLOAD_APPLICANT_DOCUMENT';
export const DOWNLOAD_APPLICANT_ZIP_DOCUMENT =
  'DOWNLOAD_APPLICANT_ZIP_DOCUMENT';

// Settings
export const CHANGE_PREFERRED_LANGUAGE = 'CHANGE_PREFERRED_LANGUAGE';

// Auth
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
